import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

export const setFilters = createAsyncThunk(
  'reportsFilters/setFilters',
  async (args: any) => {
    return args;
  },
);

const reportsFilters = createSlice({
  name: 'reportsFilters',
  initialState: {
    selectedFilters: {
      clients: '',
    },
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setFilters.fulfilled, (state, {payload}) => {
      Object.assign(state, {selectedFilters: payload});
    });
  },
});

export default reportsFilters.reducer;
